module.exports = __webpack_public_path__ + "img/canbadge-round-57mm-2.0-credit.a7592e37.png";